// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--64V94","linkSingle":"link-module--linkSingle--3YNWy","linkList":"link-module--linkList--1p1tl"};